// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"239":"e39fb35b","455":"9694b23e","977":"3e68c99d"}[chunkId] + ".chunk.js";
};